import { SearchType } from "src/store/api/generatedApi";

export const isPurchasingSearchType = (
  searchType: SearchType | null
): boolean =>
  searchType === "purchasing" || searchType === "purchasing_unrestricted";
